import { ResponseError } from '@backstage/errors';
import {




  DeploymentPlanIdResponse,











} from './types';
import axios from 'axios';
import z from 'zod';


/**
 * Options for creating a ClusterManagementClient.
 *
 * @public
 */





/**
 * An implementation of the ClusterManagementApi that talks to the access-control-backend plugin.
 *
 * @public
 */
export class DeploymentManagementClient  {
    identityApi;
    configApi;

  constructor(options) {
    this.identityApi = options.identityApi;
    this.configApi = options.configApi;
  }

  async executeDeploymentPlan(body

) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(`${dms}/dms/v1/deployments`);

    const res = await fetch(targetUrl.toString(), {
      method: 'POST',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
        : undefined,
      body: JSON.stringify(body),
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async createDeploymentPlan(body) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(`${dms}/dms/v1/deploymentPlan`);
    const axiosResponse = await axios.post(targetUrl.toString(), body, {
      params: {
        headers: token
          ? {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          }
          : undefined,
      },
    });
    return DeploymentPlanIdResponse.parse(axiosResponse.data);
  }

  async getMostRecentRelease(params

) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(
      `${dms}/dms/v1/environments/${params?.environmentId}/mrdr`,
    );

    const res = await fetch(targetUrl.toString(), {
      method: 'GET',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
        }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async getReleaseServiceVerions(params

) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(`${dms}/dms/v1/releases/${params?.releaseId}`);

    const res = await fetch(targetUrl.toString(), {
      method: 'GET',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
        }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async getReleases(params









) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(`${dms}/dms/v1/releases`);

    params?.limit && targetUrl.searchParams.set('limit', String(params.limit));
    params?.offset &&
      targetUrl.searchParams.set('offset', String(params.offset));
    params?.startDate &&
      targetUrl.searchParams.set('startDate', params.startDate);
    params?.endDate && targetUrl.searchParams.set('endDate', params.endDate);
    params?.status && targetUrl.searchParams.set('status', params.status);
    params?.environmentId &&
      targetUrl.searchParams.set('environmentId', String(params.environmentId));
    params?.serviceName &&
      targetUrl.searchParams.set('serviceName', params.serviceName);
    params?.serviceVersion &&
      targetUrl.searchParams.set('serviceVersion', params.serviceVersion);
    params?.flag && targetUrl.searchParams.set('flag', params.flag);

    const res = await fetch(targetUrl.toString(), {
      method: 'GET',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
        }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async getRelease(releaseId) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(`${dms}/dms/v1/releases/${releaseId}`);

    const res = await fetch(targetUrl.toString(), {
      method: 'GET',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
        }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async updateRelease(
    releaseId,
    body

,
  ) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(`${dms}/dms/v1/releases/${releaseId}`);

    const res = await fetch(targetUrl.toString(), {
      method: 'PUT',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
        : undefined,
      body: JSON.stringify(body),
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
  }

  async getEnvironments(params


) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(`${dms}/dms/v1/environments`);

    params?.customerName &&
      targetUrl.searchParams.set('customerName', params.customerName);
    params?.environmentName &&
      targetUrl.searchParams.set('environmentName', params.environmentName);

    const res = await fetch(targetUrl.toString(), {
      method: 'GET',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
        }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async getEnvironment(environmentId) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(`${dms}/dms/v1/environments/${environmentId}`);

    const res = await fetch(targetUrl.toString(), {
      method: 'GET',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
        }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async getUpgradeableReleases(
    environmentId,
    queryParams,
  ) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(
      `${dms}/dms/v1/environments/${environmentId}/releases`,
    );
    if (queryParams) {
      queryParams.limit &&
        targetUrl.searchParams.append('limit', String(queryParams.limit));
      queryParams.offset &&
        targetUrl.searchParams.append('offset', String(queryParams.offset));
    }

    const res = await fetch(targetUrl.toString(), {
      method: 'GET',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
        }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async getEnvironmentVariables(
    environmentId,
  ) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(
      `${dms}/dms/v1/environments/${environmentId}/variables`,
    );

    const res = await fetch(targetUrl.toString(), {
      method: 'GET',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
        }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async updateEnvironmentVariables(
    environmentId,
    body,
  ) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(
      `${dms}/dms/v1/environments/${environmentId}/variables`,
    );

    const res = await fetch(targetUrl.toString(), {
      method: 'PUT',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
        : undefined,
      body: JSON.stringify(body),
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async getDeploymentPlans(params

) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();
    const targetUrl = new URL(`${dms}/dms/v1/deploymentPlan`);
    params.environmentId &&
      targetUrl.searchParams.set('environmentId', params.environmentId);

    const res = await fetch(targetUrl.toString(), {
      method: 'GET',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
        }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async getDeploymentPlan(
    deploymentPlanId,
  ) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(
      `${dms}/dms/v1/deploymentPlan/${deploymentPlanId}`,
    );

    const res = await fetch(targetUrl.toString(), {
      method: 'GET',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
        }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async retryDeploymentStep(body


) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(`${dms}/dms/v1/deployments/retry`);
    const response = await fetch(targetUrl.toString(), {
      method: 'POST',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
        : undefined,
      body: JSON.stringify(body),
    }).then(res => res.json());
    return z.object({ message: z.string() }).parse(response);
  }

  async getEnvironmentServices(
    environmentId,
    params



,
  ) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();
    const targetUrl = new URL(
      `${dms}/dms/v1/environments/${environmentId}/services`,
    );

    params?.limit && targetUrl.searchParams.set('limit', String(params.limit));
    params?.offset &&
      targetUrl.searchParams.set('offset', String(params.offset));
    params?.includeDeleted &&
      targetUrl.searchParams.set(
        'includeDeleted',
        String(params.includeDeleted),
      );

    const res = await fetch(targetUrl.toString(), {
      method: 'GET',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
        }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async getMasterServices(params




) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();
    const targetUrl = new URL(`${dms}/dms/v1/masterServices`);

    params?.limit && targetUrl.searchParams.set('limit', String(params.limit));
    params?.offset &&
      targetUrl.searchParams.set('offset', String(params.offset));
    params?.includeDeleted &&
      targetUrl.searchParams.set(
        'includeDeleted',
        String(params.includeDeleted),
      );
    params?.includeDeprecated &&
      targetUrl.searchParams.set(
        'includeDeprecated',
        String(params.includeDeprecated),
      );

    const res = await fetch(targetUrl.toString(), {
      method: 'GET',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
        }
        : undefined,
    });

    if (!res.ok) throw await ResponseError.fromResponse(res);
    return res.json();
  }

  async updateReleaseTag(releaseId, body) {
    const dms = this.configApi.getString('backend.dms.baseUrl');
    const { token } = await this.identityApi.getCredentials();

    const targetUrl = new URL(`${dms}/dms/v1/releases/${releaseId}`);

    const res = await fetch(targetUrl.toString(), {
      method: 'PATCH',
      headers: token
        ? {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        }
        : undefined,
      body: JSON.stringify(body),
    }).then(res => {
      if (res.status !== 204) {
        return res.json();
      }
      return res;
    });

    if (!res.ok) throw res;
  }
}
